import React from 'react'
import Page from 'components/Page/Page'
import Table from 'components/Display/Table/Table'
import usePayments from 'logic/Payments/usePayments'
import {useGetPaymentsQuery, useGetPaymentQuery, useUpdatePaymentStatusMutation} from 'store/Store'
import tableActions from 'constants/tableActions'

const useDisabledDeleteMutation = () => [() => Promise.resolve(), {errorDelete: null}]

const Payments = () => {
    return (
        <Page>
            <Table
                itemName="payment"
                paginationType="external"
                allowDelete={false}
                allowEdit={false}
                allowExpanded
                useGetQuery={useGetPaymentsQuery}
                useGetByIdQuery={useGetPaymentQuery}
                useEditMutation={useUpdatePaymentStatusMutation}
                useDeleteMutation={useDisabledDeleteMutation}
                useModal={usePayments}
                tableActions={tableActions.paymentsTableActions}
            />
        </Page>
    )
}

export default Payments
